import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import adminReducer from "./slices/adminSlice";
import athleteReducer from "./slices/athleteSlice";
import coachReducer from "./slices/coachSlice";
import signupReducer from "./slices/signupSlice";
import quizReducer from "./slices/quizSlice";
import etsQuizReducer from "./slices/etsQuizSlice";
import forcedChoiceQuizReducer from "./slices/forcedChoiceQuizSlice";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        admin: adminReducer,
        athlete: athleteReducer,
        coach: coachReducer,
        signup: signupReducer,
        quiz: quizReducer,
        etsQuiz: etsQuizReducer,
        forcedChoiceQuiz: forcedChoiceQuizReducer,
    },
});